import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { billingApi } from '@/lib/api';

// V48 — Billing is workspace-scoped now. Each hook takes a workspaceId.

export const useBillingStatus = (workspaceId: string) =>
  useQuery({
    queryKey: ['billing-status', workspaceId],
    queryFn: () => billingApi.status(workspaceId),
    enabled: !!workspaceId,
  });

export const useCheckout = (workspaceId: string) => {
  return useMutation({
    mutationFn: (body: { plan: 'starter' | 'pro' | 'agency'; interval?: 'monthly' | 'annual' }) =>
      billingApi.checkout(workspaceId, body),
    onSuccess: (data) => {
      if (data.checkoutUrl) window.location.href = data.checkoutUrl;
    },
  });
};

export const useCancelSubscription = (workspaceId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => billingApi.cancelSubscription(workspaceId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['billing-status', workspaceId] });
    },
  });
};
